import { hasDeepResearchMention } from '#pplx/frontend/apps/ask/hooks/ask-deep-research-hooks/deepResearchInput.js';
import { queryInputStateContextProvider } from '#pplx/frontend/apps/ask/stores/queryInput.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useContext } from 'react';
const chipRemovedEvent = EVENT_PAYLOAD;
export function useDeepResearchChipRemovalAnalytics({ onChange, searchMode, isAskDeepResearch = false, isFollowUp = false, }) {
    const inputStore = useContext(queryInputStateContextProvider);
    const { track } = useInstrumentation();
    return useCallback((value, json) => {
        // Compare the stored draft around the accepted edit. This excludes external
        // replacements, submit resets, and stale editor updates rejected after submit.
        const previousJson = inputStore.getState().userInputJson;
        onChange(value, json);
        const nextJson = inputStore.getState().userInputJson;
        if (searchMode === SearchMode.ASI &&
            previousJson &&
            json &&
            nextJson &&
            previousJson !== nextJson &&
            hasDeepResearchMention(previousJson.root) &&
            !hasDeepResearchMention(nextJson.root)) {
            track(chipRemovedEvent({
                name: 'computer deep research chip removed',
                data: { isAskDeepResearch, isFollowUp },
            }));
        }
    }, [inputStore, isAskDeepResearch, isFollowUp, onChange, searchMode, track]);
}
//# sourceMappingURL=useDeepResearchChipRemovalAnalytics.js.map